// extracted by mini-css-extract-plugin
export default {"icon":"shared_icon__Y0cDR","iconActive":"shared_iconActive__+g4i8","favIcon":"shared_favIcon__XHc1-","path":"shared_path__GcALq"};